<template>
  <div class="cursor" @click="back">
    <div v-if="isIPhone()">
      <svg class="back" width="20px" height="28px" viewBox="0 0 20 28" version="1.1" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="chevron_back_28">
            <rect id="Body" x="0" y="0" width="20" height="28"></rect>
            <path
                d="M4.56066017,12.9393398 L13,4.5 C13.5522847,3.94771525 14.4477153,3.94771525 15,4.5 L15,4.5 C15.5522847,5.05228475 15.5522847,5.94771525 15,6.5 L7.5,14 L15,21.5 C15.5522847,22.0522847 15.5522847,22.9477153 15,23.5 L15,23.5 C14.4477153,24.0522847 13.5522847,24.0522847 13,23.5 L4.56066017,15.0606602 C3.97487373,14.4748737 3.97487373,13.5251263 4.56066017,12.9393398 Z"
                id="Chevron" fill="currentColor"></path>
          </g>
        </g>
      </svg>
    </div>

    <div v-if="! isIPhone()">
      <svg class="back" width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="arrow_left_outline_28">
            <polygon points="28 0 0 0 0 28 28 28"></polygon>
            <path
                d="M12.292893,6.292893 C12.6834173,5.90236871 13.3165827,5.90236871 13.707107,6.292893 C14.0976313,6.68341729 14.0976313,7.31658271 13.707107,7.707107 L13.707107,7.707107 L8.414,12.9999998 L22,13 C22.5128358,13 22.9355072,13.3860402 22.9932723,13.8833789 L23,14 C23,14.5522847 22.5522847,15 22,15 L22,15 L8.414,14.9999998 L13.707107,20.292893 C14.067591,20.653377 14.0953205,21.2206084 13.7902956,21.6128997 L13.707107,21.707107 C13.3165827,22.0976313 12.6834173,22.0976313 12.292893,21.707107 L12.292893,21.707107 L5.29289322,14.7071068 L5.29289322,14.7071068 L5.21968877,14.625449 C5.2173721,14.6225624 5.21507113,14.6196628 5.21278596,14.6167501 C5.20728448,14.6098424 5.20175344,14.602603 5.19633458,14.5953066 C5.17849009,14.5711307 5.1617187,14.546275 5.14606743,14.5206602 C5.13860692,14.5086131 5.13149883,14.4963944 5.12467117,14.4840621 C5.11379392,14.4642939 5.10337664,14.4438914 5.09365378,14.4230991 C5.08567905,14.4060985 5.07819642,14.3887956 5.07122549,14.371336 C5.06331574,14.3515792 5.05612249,14.3317977 5.04954668,14.3117364 C5.04472872,14.2968513 5.04009773,14.2814633 5.03584514,14.265993 C5.02983363,14.2444365 5.0246398,14.2227461 5.02016515,14.2007941 C5.01670217,14.1833753 5.01362808,14.165949 5.0110178,14.1484669 C5.00376119,14.1003621 5,14.0506203 5,14 L5.00396641,14.0892501 C5.00189498,14.0659949 5.00063489,14.042681 5.00018615,14.0193545 L5,14 C5,13.9935938 5.00006024,13.9872016 5.00018018,13.980824 C5.00059932,13.9579802 5.0018656,13.9343349 5.00396641,13.9107499 C5.00576612,13.890153 5.00811223,13.8705042 5.01101934,13.8510388 C5.01362808,13.834051 5.01670217,13.8166247 5.02024007,13.7992742 C5.0246398,13.7772539 5.02983363,13.7555635 5.03572097,13.7341604 C5.04009773,13.7185367 5.04472872,13.7031487 5.04973809,13.6878575 C5.05612249,13.6682023 5.06331574,13.6484208 5.07110396,13.6289415 C5.07819642,13.6112044 5.08567905,13.5939015 5.09367336,13.5767785 C5.10337664,13.5561086 5.11379392,13.5357061 5.12487577,13.515723 C5.13149883,13.5036056 5.13860692,13.4913869 5.14599545,13.4792912 C5.1617187,13.453725 5.17849009,13.4288693 5.19631351,13.4048407 C5.22531295,13.3656744 5.25749917,13.3282873 5.29289322,13.2928932 L5.21278596,13.3832499 C5.23766884,13.3515341 5.26442691,13.3213595 5.29289322,13.2928932 Z"
                id="↳-Icon-Color" fill="currentColor" fill-rule="nonzero"></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import {isIPhone} from "../../lib/utils";
import {store} from "../../store";

export default {
  name: "PanelHeaderBackArrow",
  methods: {
    back() {
      // уменьшаем счётчик переходов
      store.commit("decrementHistoryDepth");

      // Прямой заход на страницу
      if (store.state.history.depth === 0) {
        this.$router.push("/");
        return
      }

      this.$router.back();
    },
    isIPhone() {
      return isIPhone(this.$store);
    },
  }
}
</script>

<style scoped>
.back {
  margin-top: -1px;
  margin-right: 7px;
}

.cursor {
  cursor: pointer;
}
</style>